module.exports = __webpack_public_path__ + "img/close-pink.d2621823.svg";